<template>
    <v-dialog v-model="dialog" persistent content-class="modal-dialog">
        <v-card class="modal-adaptive">
            <div class="common-text text-center mb-2">
                Редактирование сценария
            </div>
            <div class="main-text mb-2">
                Выберете дни недели для активации сценария
            </div>
            <v-layout row class="devices-list__block__title">
                <v-flex class="d-inline-flex">
                    <div
                        v-for="(day, index) in weekdays"
                        :key="index"
                        class="weekday"
                        :class="{'weekday__active': scenarioDays.includes(index)}"
                        @click="setDay(index)"
                    >
                        {{ day }}
                    </div>
                </v-flex>
            </v-layout>
            <div class="main-text mt-3 mb-2">
                Время активации сценария
            </div>
            <v-flex class="modal-row d-flex justify-space-between mb-6">
                <v-text-field
                    v-model="time"
                    placeholder="Время"
                    type="time"
                    class="input-picker-grey"
                    dense
                    hide-details
                ></v-text-field>
            </v-flex>
            <v-flex class="modal-row d-flex justify-end">
                <v-btn class="btn-grey main-text" @click="cancel">
                    Отмена
                </v-btn>
                <v-btn class="btn-gradient main-text" @click="addGuest">
                    Установить
                </v-btn>
            </v-flex>
        </v-card>
        <ModalWaiting ref="modalWaiting" title="Редактирование сценария" :text="textModal"></ModalWaiting>
    </v-dialog>
</template>

<script>
import ModalWaiting from "@/components/modals/ModalWaiting";

export default {
    name: "ModalSetScenario",
    components: {ModalWaiting},
    props: {
        value: {
            type: Boolean,
        },
        scenario: {
            type: Object,
        },
        close: {
            type: Function,
            default: () => {},
        },
    },
    data() {
        return {
            dialog: false,
            time: "12:00",
            textModal: "Обновление...",
            weekdays: ["ПН", "ВТ", "СР", "ЧТ", "ПТ", "СБ", "ВС"],
            scenarioDays: [],
        }
    },
    watch: {
        value(val) {
            if (val != this.dialog) {
                this.dialog = val;
                if (this.scenario) {
                    this.time = JSON.parse(JSON.stringify(this.scenario.time_start));
                    this.scenarioDays = JSON.parse(JSON.stringify(this.scenario.weekdays));
                }
            }
        },
    },
    methods: {
        open() {
            this.dialog = true;
        },
        cancel() {
            this.dialog = false;
            if (this.close) {
                this.close();
            }
            this.$emit('input', false);
        },
        addGuest() {
            this.$refs.modalWaiting.open();
            this.dialog = false;
            this.$http.put('/scenarios/guest/scenario/' + this.scenario.uid + '/set-time', {
                "time_start": this.time,
                "weekdays": this.scenarioDays,
            })
                .then((response) => {
                    this.$refs.modalWaiting.close();
                    this.$emit("updateScenario", response.data);
                    this.cancel();
                })
                .catch((error) => {
                    console.log(error);
                    this.cancel();
                    this.$refs.modalWaiting.close();
                });
        },
        setDay(i) {
            let index = this.scenarioDays.indexOf(i);
            if (index != -1) {
                this.scenarioDays.splice(index, 1);
            } else {
                this.scenarioDays.push(i);
            }
        },
    }

}
</script>

<style lang="scss" scoped>
.btn-grey.v-btn {
    max-width: 94px;
    text-transform: none;
    margin-right: 10px;
}

.btn-gradient.v-btn {
    max-width: 165px;
}
</style>